<style scoped>

  .content {
    padding: 5px 20px 20px 20px !important;
  }

</style>

<template>

  <div class="ui fluid styled accordion">

    <div id="filters-button" class="title" :class="{ active }">
      <i class="dropdown icon"></i>
      Filtros
    </div>

    <div class="content" :class="{ active }">

      <form class="ui form" @submit.prevent="onSearch()" :class="{ loading }">
        <div class="fields">                    
          <div class="three wide field">
            <label class="form-label">Data Inicial <span class="red text">*</span></label>
            <div id="start-date" class="ui calendar">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" class="date">
              </div>
            </div>
          </div>
          <div class="three wide field">
            <label class="form-label">Data Final <span class="red text">*</span></label>
            <div id="end-date" class="ui calendar">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" class="date">
              </div>
            </div>
          </div> 
          <div v-if="!$isCustomerOrProspect()" class="three wide field">
            <label class="form-label">Unidade</label>
            <select id="select-branch" class="ui fluid dropdown form-dropdown" v-model="filter.branch">
              <option value="*">Todas</option>
              <option v-for="branch in branches" :value="branch.id">{{ branch.name }}</option>                            
            </select>
          </div>
          <div class="three wide field">
            <label class="form-label">Número da Reserva</label>
            <input type="text" maxlength="6" v-model="filter.reserveId">
          </div>
          <div class="four wide field">
            <label class="form-label">Status</label>
            <select id="select-status" class="ui fluid dropdown form-dropdown" v-model="filter.status">
              <option value="*">Todos</option>
              <option value="1"><i class="clock yellow icon"></i> Pendente</option>
              <option value="2"><i class="check circle green icon"></i> Confirmada</option>
              <option value="3"><i class="exclamation circle icon"></i> Expirada</option>
              <option value="4"><i class="times red icon"></i> Cancelada</option>
            </select>
          </div>
        </div>   
        <div v-if="!$isCustomerOrProspect()" class="fields">          
          <div class="five wide field">
            <label class="form-label">Cliente</label>
            <select id="select-customer" class="ui fluid search dropdown form-dropdown" v-model="filter.customer">
              <option value="*">Todos</option>
              <option v-for="customer in $store.state.reservesCustomers" :value="customer.id">{{ customer.value }}</option>
            </select>
          </div>
          <div v-if="!$store.state.user.isSeller" class="five wide field">
            <label class="form-label">Representante</label>
            <select id="select-seller" class="ui fluid search dropdown form-dropdown" v-model="filter.seller">
              <option value="*">Todos</option>
              <option v-for="seller in $store.state.reservesSellers" :value="seller.id">{{ seller.value }}</option>                            
            </select>
          </div>
          <div class="six wide field">
            <label class="form-label">Responsável</label>
            <select id="select-user" class="ui fluid search dropdown form-dropdown" v-model="filter.user">
              <option value="*">Todos</option>
              <option v-for="user in $store.state.reservesUsers" :value="user.id">{{ user.value }}</option>                            
            </select>
          </div>
        </div>                    
        <button class="ui basic blue icon button" :class="{ loading: searching }" 
          type="submit" style="margin-top: 10px;">
          <i class="search icon"></i>
          Pesquisar
        </button>
      </form>

    </div>

  </div>

</template>

<script>

  import { Calendar, Message, moment } from "@/utils"
  import { OppBalanceService } from "@/services"

  export default {

    data() {
      return {
        loading: true,
        branches: [],        
        filter: {
          startDate: null,
          endDate: null,
          branch: "*",
          reserveId: "",
          status: "*",
          customer: "*",
          seller: "*",
          user: "*",
        },        
      }
    },

    props: ["active", "searching"],

    created() {

      if (this.$store.state.user.isSeller) {
        this.branches = this.$store.state.user.seller.branches.slice()
      } else {
        this.branches = [
          { id: "01", name: "Itu" },
          { id: "02", name: "Três Lagoas" },
        ]
      }
    },

    mounted() {

      $(".accordion").accordion()

      Calendar.initInputs()           

      $(".form-dropdown").dropdown({
        fullTextSearch: true,
      })

      this.loadData()
    },

    methods: {

      async loadData() {

        this.loading = true

        try {

          if (!this.$isCustomerOrProspect() && this.$store.state.reservesCustomers.length == 0)
            this.$store.commit("setReservesCustomers", await OppBalanceService.getEntities("customer"))

          if (!this.$isCustomerOrProspect() && !this.$store.state.user.isSeller && this.$store.state.reservesSellers.length == 0)
            this.$store.commit("setReservesSellers", await OppBalanceService.getEntities("seller"))

          if (!this.$isCustomerOrProspect() && this.$store.state.reservesUsers.length == 0)
            this.$store.commit("setReservesUsers", await OppBalanceService.getEntities("user"))  

          this.updateFilters()  
          
          this.loading = false
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },      

      updateFilters() {

        let startDate = null
        let endDate = null

        if (this.$store.state.reservesFilter) {
          startDate = this.$store.state.reservesFilter.startDate
          endDate = this.$store.state.reservesFilter.endDate
          this.filter = this.$cloneObject(this.$store.state.reservesFilter)
        } else {
          startDate = moment().subtract(1, "days").toDate()
          endDate = new Date()
        }

        $("#start-date").calendar("set date", moment(startDate).toDate())
        $("#end-date").calendar("set date", moment(endDate).toDate())

        $("#select-status").dropdown("set selected", this.filter.status) 

        if (!this.$isCustomerOrProspect()) {
          $("#select-branch").dropdown("set selected", this.filter.branch)
          $("#select-customer").dropdown("set selected", this.filter.customer)
          $("#select-seller").dropdown("set selected", this.filter.seller)
          $("#select-user").dropdown("set selected", this.filter.user)
        }          
      },

      onSearch() {    

        this.filter.startDate = $("#start-date").calendar("get date")
        this.filter.endDate = $("#end-date").calendar("get date")

        if (this.filter.customer != "*") {
         this.filter.customerCode = this.filter.customer.substring(0, 6)
         this.filter.customerUnit = this.filter.customer.substring(6)
        } else {
          this.filter.customerCode = ""
          this.filter.customerUnit = ""
        }

        let data = this.$cloneObject(this.filter)

        this.$store.commit("setReservesFilter", data)

        if (data.branch == "*")
          data.branch = ""

        if (data.status == "*")
          data.status = ""  

        if (data.customer == "*")
          data.customer = ""  

        if (data.seller == "*")
          data.seller = ""  

        if (data.user == "*")
          data.user = ""          

        this.$emit("onSearch", data)
      },

      toggleActive() {
        $("#filters-button").click()
      },
    },
  }

</script>
